import styled from 'styled-components';
export const Container = styled.div`
   display: flex;
  height: 100%;
  width: 100%;
  flex-direction:column;
  cursor:default;

  span{
    display:flex;
    text-align: center;
  }
  
`
